import { useMemo } from 'react';

import type { SignPetitionInput } from '#src/app/shared/api/signature';
import { useCurrentUserAsync } from '#src/app/shared/hooks/session';
import { isLoaded } from '#src/app/shared/utils/async';

type Result = Pick<
	SignPetitionInput,
	'firstName' | 'lastName' | 'city' | 'postalCode' | 'stateCode' | 'countryCode' | 'phoneNumber'
> & {
	email?: string;
	userId?: string;
};

export function useCurrentUserSignData(): Result {
	const currentUserState = useCurrentUserAsync();

	return useMemo(() => {
		if (!isLoaded(currentUserState) || !currentUserState.value) {
			return {
				firstName: '',
				lastName: '',
				city: '',
				postalCode: '',
				stateCode: '',
				countryCode: '',
				// Phone number input is currently only enabled for guests
				phoneNumber: null,
			};
		}

		const { country, city, stateCode, postalCode, firstName, lastName, id } = currentUserState.value;

		// weirdly, non-guest users are allowed to sign without a city/postalCode/stateCode/countryCode, while guests cannot...
		return {
			userId: id,
			firstName,
			lastName,
			city: city || '',
			postalCode: postalCode || '',
			stateCode: stateCode || '',
			countryCode: country?.countryCode || '',
			// Phone number input is currently only enabled for guests
			phoneNumber: null,
		};
	}, [currentUserState]);
}
